import { PrinterStation } from '@models/payload/printer';
import { STORES, initDB } from './config';

const { PRINTER_STATION_STORE } = STORES;

export const savePrinterStationData = async (printerStations: PrinterStation[]): Promise<void> => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(PRINTER_STATION_STORE, 'readwrite');
    const store = transaction.objectStore(PRINTER_STATION_STORE);

    // Clear existing data
    store.clear();

    // Add new data
    printerStations.forEach((item) => {
      store.put(item);
    });

    transaction.oncomplete = () => {
      db.close();
      resolve();
    };

    transaction.onerror = () => {
      db.close();
      reject(transaction.error);
    };
  });
};

export const getPrinterStationData = async (): Promise<PrinterStation[]> => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(PRINTER_STATION_STORE, 'readonly');
    const store = transaction.objectStore(PRINTER_STATION_STORE);
    const request = store.getAll();

    request.onsuccess = () => {
      db.close();
      resolve(request.result);
    };

    request.onerror = () => {
      db.close();
      reject(request.error);
    };
  });
};
